import React, { useState, Children, cloneElement } from 'react';

import helpers from './helpers';
import isNumber from 'lodash/isNumber';

type Props = {
  children: Node,
  className?: string,
  schemeMode?: 'dark' | 'light',
  mode?: 'Meal' | 'MealDealCategories',
  type?: 'line' | 'card',
  activeIndex?: Number,
  lastElSticky?: Boolean,
};

export const Tabs = ({ children, className, schemeMode, mode, type, activeIndex, lastElSticky }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onClick = dataIndex => {
    setSelectedIndex(dataIndex);
  };
  const mappedTabLists = Children.toArray(children)
    .filter(child => helpers.isTabList(child))
    .map(el =>
      cloneElement(el, {
        onClick,
        selectedIndex: isNumber(activeIndex) ? activeIndex : selectedIndex,
        schemeMode,
        mode,
        type,
        lastElSticky,
      })
    );

  const tabPanels = Children.toArray(children)
    .filter(child => helpers.isTabPanel(child))
    .map(el =>
      cloneElement(el, {
        schemeMode,
      })
    );

  return (
    <div className={className}>
      {mappedTabLists}
      {tabPanels[selectedIndex]}
    </div>
  );
};